import styled from 'styled-components';
import BGBanner from '../../assests/images/bg-banner.webp';
import RightBlue from '../../assests/images/check.png';

export const DonateNowSection = styled.div`
   position: relative; 
   padding-top:93px;
   padding-bottom: 168px;
   background-image:url(${BGBanner});
   background-color: #dcf4f6;

   @media screen and (max-width:1199px) {
    padding-top: 199px;
    padding-bottom: 155px;
   }
   @media screen and (max-width:767px) {
    padding-top: 150px;
    padding-bottom: 160px;
  }
`;
export const DonateNowWrapper = styled.div`
.btn-outline-success {
    padding: 12px 73px !important;
}

  
`;
export const EmptyBasket = styled.h3`
   color: #333333;
   font-family: "Jost", sans-serif;
   font-size:20px;
   font-weight: 400;
    line-height: 20px;
    margin-bottom: 20px;
   margin-top": 20px;
`;

export const Title = styled.h1`
   color: #01606F;
   font-family: "Jost", sans-serif;
   font-size: 40px;
   font-weight: 700; 
   line-height: 30px;
   margin-bottom: 30px;

   @media screen and (max-width:1199px) {
    font-size: 36px;
    line-height: 40px;

    }

   @media screen and (max-width:991px) {
        font-size: 35px;
        line-height: 40px;
    }
   
   @media screen and (max-width:767px) { 
        font-size: 33px;
        line-height: 35px;
   }
   
   @media screen and (max-width:575px) {
        font-size: 30px;
        line-height: 35px;
    }
`;

export const ReviewSerchBox = styled.div`
.search-header{
    display: flex;
    align-items: center;
    background: #fff;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 10px;
    padding:6px;
    width: 100%;
    justify-content: space-between;

    .zipcode{
        max-width: 150px;
      .form-control{
         padding-left: 20px !important;
       }
        
        &:after {
            background: #333333;
            position: absolute;
            width: 1px;
            height: 40px;
            content: "";
            top: -5px;
        }
    }
   
    .input-group{
        width: auto;
       
        .form-control{
            border: none;
            padding-top: 2px;
            padding-bottom: 2px;
            font-family: "Jost", sans-serif;
            font-size: 18px;
            font-weight: 500;
            line-height: 26px;
            padding-left: 0px;
            &:focus{
                background: transparent !important;
            }
             &::-webkit-input-placeholder { 
                  color: #333333;
                }
             &::-moz-placeholder { 
                color: #333333;
                }
             &:-ms-input-placeholder { 
                 color: #333333;
                }
             &:-moz-placeholder { 
                color: #333333;
             }
        }
    }
    .btn-outline-success{
        background: #01606F;
        border: none;
        color: #fff;
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        padding: 12px 40px;
        transition: all 0.5s;

        &:hover{
            background: #FFD495;
            color: #333333;
            transition: all 0.5s;
        }
    }
}
`;

export const InputGroupIcon = styled.div`
    padding-right: 10px;

    .search-group-icon{
        width: 48px;
        min-width:48px;
        height: 48px;
        background: #F9DC70;
        border-radius: 10px;
        padding: 10px;
    }

`;


export const ReviewRightSection = styled.div`
    background: #FFFFFF ;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding: 10px;
    
    img{
        width:100%;
    }
`;


export const BasketSummary = styled.section`
position: relative;
padding-bottom: 50px;
margin-top: -166px;

    &:after {
        background: #F1FEFF;
        position: absolute;
        width: 100%;
        height: 100%;
        content: "";
        top: 0;
        z-index: -1;
    }  
`;

export const BasketWrapper = styled.div`
    display: flex;
    gap: 24px;
    padding-top: 30px;
    @media screen and (max-width:991px) {
        flex-wrap: wrap;
        justify-content: center;
     }

`;

export const SummaryLeft = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000000D;
    border-radius: 20px;
    width:100%;
    max-width:894px;
    padding:20px;

    @media screen and (max-width: 991px){
        max-width: 100%;
    }

    .donate-now-btn{
        display:none;
    }
 &.carttext-col .error{
     font-size:18px;
 } 
`;

export const SummaryRight = styled.div`
    width:100%;
    max-width:282px;

    @media screen and (max-width: 991px){
        max-width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: row;
        gap: 40px;
    }
    
    @media screen and (max-width: 767px){
        gap: 20px;
    }

    @media screen and (max-width: 480px){
        flex-direction: column;
    }
`;


export const SummaryTitle = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 20px;
   
`;

export const SummaryBox = styled.div`
    background: #F2F2F2;
    border-radius: 15px;
    padding: 10px 21px 21px 21px;
    margin-bottom:20px;
    
    &:last-child{
        margin-bottom:0px;
    }
    @media screen and (max-width:767px) {
        padding: 10px;
        display: flex;
        flex-direction: column;
        row-gap: 15px;
    }
`;


export const BoxTitle = styled.h3`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 500;
    line-height: 30px;
    
    @media screen and (max-width:991px) {
        white-space: normal;
    }
        
    @media screen and (max-width:767px) {
        font-size: 16px;
        line-height: 25px;
        white-space: normal;
    }
`;


export const Foundation = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    @media screen and (max-width: 991px){
        flex-direction: column;
        align-items: flex-start;
        row-gap: 15px;
    }

    @media screen and (max-width: 767px){
        margin-bottom: 0px;
    }

    .inputbox {
        font-weight: 700 !important;
        color: #01606F;
        background: #FFFFFF !important ;
    }
    .inputtext{
        background: #FFFFFF !important ;
    }
`;
export const SummaryTotal = styled.div`
    background: #FFD495 0% 0% no-repeat padding-box;
    border-radius: 20px;
    padding:20px;
`;

export const TotalTile = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 600;
    line-height: 30px;
    margin-bottom:30px;
    @media screen and (max-width:1199px) {
        margin-bottom:20px; 
    }
    @media screen and (max-width:991px) {
        font-size:18px;
        line-height: 25px;
       margin-bottom:10px;
     }
`;

export const DonateDelete = styled.div`
   display: flex;
    gap: 10px;
    width: 100%;
    max-width: 299px;
    justify-content: end;
`;

export const Icon = styled.span`
    background: #E63D50;
    border-radius: 10px;
    width:48px;
    min-width:48px;
    height:48px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width:1199px) {
        width: 40px;
        min-width:40px;
        height: 40px;
        border-radius: 7px;
     }
    @media screen and (max-width:991px) {
        width: 40px;
        min-width: 40px;
        height: 40px;
        border-radius: 5px;
        margin-top: 4px;
     }
   .btn.btn-primary{
        background: transparent;
        border: none;
    }

`;


export const CustomCheckbox = styled.div`
    display: flex;
    align-items: start;
    .tooltipBtn{
        background: transparent;
        border: none;
        padding: 2px 12px;
    &:active{
        background: transparent;
    } 
    }
    .form-check{
        width: 100%;
        max-width: 280px;
    }
    .form-check-input{
        width: 24px;
        height: 24px;
        margin-right: 6px;
    }
    .form-check-label {
        color: #333333;
        font-size: 14px;
        font-weight: 500;
        font-family: "Jost", sans-serif;
        line-height: 25px;
        display: inline-block;
        padding-top: 3px;
        cursor: pointer;
        @media screen and (max-width:767px) { 
            line-height: 20px;
        }
    }
    .form-check-input:checked {
        background-color: #000;
        border-color: #000;
    }
    .form-check-input:focus {
    box-shadow: none;
    border:none;
    }
    .form-check-input {
        --bs-form-check-bg:  rgb(0 0 0 / 50%);
        border-radius: 7px;
    }
    .checkbox{
        max-width:100%;
    }
`;

export const PopoverSection = styled.div`

    .popover-body{
        color: #000000;
        font-size: 14px;
        line-height: 18px;
        font-family: "Jost", sans-serif;
        padding:20px !important;
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 20px #00000029;
        border: 2px solid #FFFFFF33;
        border-radius: 15px;
        z-index:99;
        width:100%;
        min-width:380px;
        @media screen and (max-width:767px) { 
            padding:10px !important; 
            width:100%;
            min-width: inherit;
        }
    }
    .popover-basic{
        border:none !important;
    }
    .popover-arrow {
        display: none !important;
    }
`;


export const SummaryBlueBox = styled.div`
    background: #01606F 0% 0% no-repeat padding-box;
    border-radius: 10px;
    padding:15px;
    width:100%;
    max-width:340px;
    margin-top: 12px;
    margin-bottom: 15px;
    .inputbox.form-control{
        height: 48px;
        margin-top: 15px;
        font-weight: 400;
        font-size: 18px;
        line-height: 18px;
        font-family: "Jost", sans-serif;
    }
`;

export const RadioBox = styled.div`
    display: flex;
    align-items: center;
    gap: 31px;
`;
export const CustomRadioBox = styled.div`
    display: flex;
    align-items: center;
    .form-check-label {
        color: #FFFFFF;
        font-size: 14px;
        line-height: 18px;
        font-family: "Jost", sans-serif;
    }
    .form-check-input {
        width: 20px;
        height: 20px;
        margin-right: 10px;
    }
    .form-check-input {
        --bs-form-check-bg:rgb(255 255 255 / 70%);
        border: none;
    }
    .form-check-input:checked[type=radio]{
        --bs-form-check-bg-image:url(${RightBlue});
        background-size: 12px;
        background-position: 54% 59%;
    }
    .form-check-input:checked {
        background-color:#FFFFFF;
    }
`;

export const CheckBoxText = styled.p`
    color: #333333;
    font-size: 13px;
    line-height: 21px;
    padding-left:40px;
    margin-top: 1px;
    margin-bottom: 0;
    font-family: "Jost", sans-serif;
   &.TextCol{
    padding-left: 0px;
   } 
`;
export const SubTitle = styled.span`
    color: #333333;
    font-size: 16px;
    line-height: 30px;
    font-family: "Jost", sans-serif;
    font-weight: 400;
`;
export const TotalItem = styled.li`
     display: flex;
     margin-bottom: 20px;
    justify-content: space-between;
    gap:10px;
    @media screen and (max-width:1199px) {
        margin-bottom: 15px;
     }
`;
export const TotalList = styled.ul`
    padding: 0;
    margin: 0;
    list-style: none;
    border-bottom: 1px solid rgb(51 51 51 / 50%);
    
    &.TotalAmount{
        margin-top: 20px;
        border-bottom: 0;

        @media screen and (max-width:767px) {
            margin-top: 15px;
        }
       ${SubTitle}{
        font-weight: 600;
       } 
      ${TotalItem}{
        margin-bottom: 0px;
      }


    }
`;




export const TotalAmount = styled.strong`
    color: #333333;
    font-size: 16px;
    line-height: 30px;
    font-family: "Jost", sans-serif;
    font-weight: 600;
`;



export const SummaryRightWrapper = styled.div`
background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 20px 20px #0000000D;
border-radius: 20px;
@media screen and (max-width:768px){
      width:100%;
   }
`;

export const CaptchaImage = styled.div`
padding: 10px;
img{
    width:100%;
  }
`; 

export const DonationWrapper = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 30px #00000014;
    border-radius: 15px;
    padding:15px;
    margin-top:20px;

    @media screen and (max-width: 991px){
        margin-top: 0px;
    }
    
    @media screen and (max-width: 480px){
        margin: 0 auto;
    }
`;

export const  DonateImageCol = styled.div`
    width:241px;
    min-width:241px;
    height:241px;
    margin:0  auto;
    img{
        display:block;
        margin:0 auto;
        width:100%;
    }
`;